/* Vape Studio theme script
 * - Header: mobile menu, search panel, sticky/transparent state
 * - Accordions and collection tabs
 * - Product cards: variant + quantity selection, WhatsApp order requests
 * - Order list (browser-only) sent as one WhatsApp order request
 * - Scroll reveal and carousels
 * No payments, no Shopify cart/checkout calls.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('ThemeConfig');
  var CONFIG = {};
  try { CONFIG = configEl ? JSON.parse(configEl.textContent) : {}; } catch (e) { CONFIG = {}; }
  var S = CONFIG.strings || {};

  /* ---------------- Utilities ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function validNumber() {
    var n = String(CONFIG.whatsappNumber || '').replace(/\D/g, '');
    return /^\d{8,15}$/.test(n) ? n : null;
  }

  function shopText(str) {
    return String(str || '').split('[shop]').join(CONFIG.shopName || '');
  }

  var toastTimer;
  function toast(message, ms) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, ms || 4000);
  }

  function itemLine(item, index) {
    var parts = [];
    var title = item.title;
    if (item.variantTitle && !item.hasOnlyDefault) title += ' — ' + item.variantTitle;
    parts.push(title);
    if (item.sku) parts.push((S.sku || 'SKU') + ': ' + item.sku);
    parts.push((S.quantity || 'Quantity') + ': ' + item.quantity);
    if (CONFIG.includePrice && item.price) parts.push((S.price || 'Listed price') + ': ' + item.price);
    if (CONFIG.includeUrl && item.url) parts.push(item.url + (item.hasOnlyDefault ? '' : '?variant=' + item.variantId));
    return (typeof index === 'number' ? (index + 1) + '. ' : '- ') + parts.join(' | ');
  }

  function buildMessage(items) {
    var lines = [shopText(CONFIG.greeting), ''];
    items.forEach(function (it, i) { lines.push(itemLine(it, items.length > 1 ? i : undefined)); });
    if (CONFIG.closing) { lines.push(''); lines.push(shopText(CONFIG.closing)); }
    return lines.join('\n');
  }

  function waUrl(text) {
    var n = validNumber();
    if (!n) return null;
    return 'https://wa.me/' + n + '?text=' + encodeURIComponent(text);
  }

  /* Opens WhatsApp. Never reports the order as sent — only that WhatsApp is opening. */
  function openWhatsApp(text) {
    var url = waUrl(text);
    if (!url) { toast(S.invalidNumber, 6000); return false; }
    // Note: passing "noopener" makes window.open return null, so detach the opener manually.
    var win = window.open(url, '_blank');
    if (win) { try { win.opener = null; } catch (e) { /* ignore */ } }
    if (!win) {
      // Pop-up blocked or no handler: try same-tab navigation, then show fallback text.
      try { window.location.href = url; } catch (e) { /* ignore */ }
      toast(S.blocked, 9000);
      return false;
    }
    toast(S.opening, 3500);
    return true;
  }

  /* ---------------- Product cards ---------------- */
  function readProduct(card) {
    if (card._product) return card._product;
    var el = $('script[data-product-json]', card);
    if (!el) return null;
    try { card._product = JSON.parse(el.textContent); } catch (e) { card._product = null; }
    return card._product;
  }

  function currentVariant(card, product) {
    var select = $('[data-variant-select]', card);
    // An option picker that matches no variant leaves the value empty: nothing is selected.
    if (select && select.value === '') return null;
    var id = select ? Number(select.value) : null;
    var variants = product.variants || [];
    if (id) {
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    }
    for (var j = 0; j < variants.length; j++) if (variants[j].available) return variants[j];
    return variants[0] || null;
  }

  function qtyLimits(input) {
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10) || 99;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    return { min: Math.max(1, min), max: Math.max(min, max), step: Math.max(1, step) };
  }

  function clampQty(input, value) {
    var l = qtyLimits(input);
    var q = parseInt(value, 10);
    if (!q || q < l.min) q = l.min;
    if (q > l.max) q = l.max;
    // Snap to the quantity increment, counted from the minimum.
    q = l.min + Math.round((q - l.min) / l.step) * l.step;
    if (q > l.max) q -= l.step;
    return Math.max(l.min, q);
  }

  function currentQty(card) {
    var input = $('[data-qty-input]', card);
    if (!input) return 1;
    var q = clampQty(input, input.value);
    if (String(q) !== input.value) input.value = q;
    return q;
  }

  function cardItem(card) {
    var product = readProduct(card);
    if (!product) return null;
    var v = currentVariant(card, product);
    if (!v || !v.available) { toast(S.chooseVariant); return null; }
    return {
      key: String(v.id),
      productId: product.id,
      variantId: v.id,
      title: product.title,
      variantTitle: v.title,
      hasOnlyDefault: !!product.hasOnlyDefault,
      sku: v.sku || '',
      price: v.price || '',
      url: product.url,
      image: product.image,
      quantity: currentQty(card)
    };
  }

  function setAll(card, sel, fn) { $$(sel, card).forEach(fn); }

  function syncCard(card) {
    var product = readProduct(card);
    if (!product) return;
    var v = currentVariant(card, product);
    var available = !!(v && v.available);

    if (v) {
      setAll(card, '[data-price]', function (el) { el.textContent = v.price; });
      setAll(card, '[data-compare]', function (el) {
        el.hidden = !v.compare;
        var cv = $('[data-compare-value]', el);
        if (cv) cv.textContent = v.compare || '';
      });
      setAll(card, '[data-sku]', function (el) { el.hidden = !v.sku; });
      setAll(card, '[data-sku-value]', function (el) { el.textContent = v.sku || ''; });
    }
    setAll(card, '[data-sale-badge]', function (el) { el.hidden = !(v && v.compare && v.available); });
    setAll(card, '[data-soldout-badge]', function (el) { el.hidden = !v || v.available; });

    // Quantity rules follow the selected variant (product page only provides them).
    var qtyInput = $('[data-qty-input]', card);
    if (qtyInput && v && v.qmin) {
      qtyInput.setAttribute('min', v.qmin);
      qtyInput.setAttribute('max', v.qmax || 99);
      qtyInput.setAttribute('step', v.qstep || 1);
      qtyInput.value = clampQty(qtyInput, qtyInput.value);
    }

    $$('[data-order-action]', card).forEach(function (btn) {
      if (btn.tagName === 'BUTTON') btn.disabled = !available;
      btn.classList.toggle('is-disabled', !available);
      if (available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
    });

    // Keep the buy links' href accurate for middle-click / copy link.
    if (available) {
      var item = { title: product.title, variantTitle: v.title, hasOnlyDefault: !!product.hasOnlyDefault, variantId: v.id, sku: v.sku, price: v.price, url: product.url, quantity: currentQty(card) };
      var url = waUrl(buildMessage([item]));
      if (url) setAll(card, 'a[data-order-action="buy"]', function (a) { a.setAttribute('href', url); });
    }

    if (card.hasAttribute('data-product-page')) syncProductPage(card, product, v);
  }

  /* ---------------- Product page: option picker ---------------- */
  function selectedOptions(card) {
    var picker = $('[data-variant-picker]', card);
    if (!picker) return null;
    var values = [];
    $$('[data-option-index]', picker).forEach(function (el) {
      var i = Number(el.getAttribute('data-option-index'));
      if (el.tagName === 'SELECT') values[i] = el.value;
      else if (el.checked) values[i] = el.value;
    });
    return values;
  }

  function matchVariant(product, values) {
    return (product.variants || []).filter(function (v) {
      return (v.options || []).every(function (o, i) { return values[i] === undefined || o === values[i]; });
    })[0] || null;
  }

  function onOptionChange(card) {
    var product = readProduct(card);
    var values = selectedOptions(card);
    if (!product || !values) return;
    var v = matchVariant(product, values);
    card._userChanged = true;
    var hidden = $('[data-variant-select]', card);
    if (hidden) hidden.value = v ? v.id : '';
    var msg = $('[data-variant-msg]', card);
    if (msg) msg.hidden = !!v;
    values.forEach(function (val, i) {
      var chosen = $('[data-option-chosen="' + i + '"]', card);
      if (chosen) chosen.textContent = val;
    });
    syncCard(card);
  }

  function syncProductPage(card, product, v) {
    // Mark option values that can't be combined with the other current selections.
    var values = selectedOptions(card);
    if (values) {
      $$('[data-option-index]', card).forEach(function (el) {
        var i = Number(el.getAttribute('data-option-index'));
        var opts = el.tagName === 'SELECT' ? $$('option', el) : [el];
        opts.forEach(function (opt) {
          var test = values.slice(); test[i] = opt.value;
          var m = matchVariant(product, test);
          var ok = !!(m && m.available);
          if (opt.tagName === 'OPTION') {
            opt.textContent = opt.value + (ok ? '' : ' — ' + (m ? S.soldOut : S.unavailable));
          } else {
            var label = card.querySelector('label[for="' + opt.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !ok);
          }
        });
      });
    }
    if (!v) return;
    if (card._userChanged && card.getAttribute('data-update-url') === 'true' && !product.hasOnlyDefault && window.history && history.replaceState) {
      try { history.replaceState(history.state, '', product.path + '?variant=' + v.id); } catch (e) { /* ignore */ }
    }
    if (v.mediaId && card._userChanged) Gallery.goToMedia(card, v.mediaId);
  }

  document.addEventListener('change', function (e) {
    var card = e.target.closest('[data-product-card]');
    if (!card) return;
    if (e.target.matches('[data-option-index]')) { onOptionChange(card); return; }
    if (e.target.matches('[data-variant-select]') || e.target.matches('[data-qty-input]')) syncCard(card);
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-product-card]');
      var input = wrap && $('[data-qty-input]', wrap);
      if (input) {
        var dir = Number(step.getAttribute('data-qty-step'));
        input.value = clampQty(input, (parseInt(input.value, 10) || 0) + dir * qtyLimits(input).step);
        syncCard(wrap);
      }
      return;
    }

    var action = e.target.closest('[data-order-action]');
    if (action) {
      var card = action.closest('[data-product-card]');
      if (!card) return;
      e.preventDefault();
      if (action.classList.contains('is-disabled') || action.disabled) return;
      var item = cardItem(card);
      if (!item) return;
      var type = action.getAttribute('data-order-action');
      if (type === 'add' && CONFIG.listBehavior === 'order_list' && $('[data-order-drawer]')) {
        OrderList.add(item);
        toast(S.added, 2500);
        Drawer.open(action);
      } else {
        openWhatsApp(buildMessage([item]));
      }
    }
  });

  /* ---------------- Order list (localStorage) ---------------- */
  var OrderList = {
    key: CONFIG.storageKey || 'vs-order-list',
    read: function () {
      try {
        var raw = window.localStorage.getItem(this.key);
        var data = raw ? JSON.parse(raw) : [];
        return Array.isArray(data) ? data : [];
      } catch (e) { return this._mem || []; }
    },
    write: function (items) {
      this._mem = items;
      try { window.localStorage.setItem(this.key, JSON.stringify(items)); } catch (e) { /* storage unavailable: keep in memory */ }
      render();
    },
    add: function (item) {
      var items = this.read();
      var found = items.filter(function (i) { return i.key === item.key; })[0];
      if (found) found.quantity = Math.min(99, found.quantity + item.quantity);
      else items.push(item);
      this.write(items);
    },
    setQty: function (key, qty) {
      var items = this.read().map(function (i) { if (i.key === key) i.quantity = qty; return i; }).filter(function (i) { return i.quantity > 0; });
      this.write(items);
    },
    clear: function () { this.write([]); },
    count: function () { return this.read().reduce(function (t, i) { return t + i.quantity; }, 0); }
  };

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function iconSvg(path) {
    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';
  }

  function render() {
    var items = OrderList.read();
    var count = items.reduce(function (t, i) { return t + i.quantity; }, 0);
    $$('[data-order-count-badge]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    $$('[data-order-count]').forEach(function (b) { b.textContent = count; });
    var list = $('[data-order-items]');
    if (!list) return;
    $('[data-order-empty]').hidden = items.length > 0;
    $('[data-order-foot]').hidden = items.length === 0;
    list.innerHTML = items.map(function (it) {
      var title = escapeHtml(it.title) + (it.hasOnlyDefault ? '' : ' — ' + escapeHtml(it.variantTitle));
      var meta = [];
      if (it.sku) meta.push((S.sku || 'SKU') + ' ' + escapeHtml(it.sku));
      if (it.price) meta.push(escapeHtml(it.price));
      return '<li class="drawer__item">' +
        '<div class="drawer__thumb">' + (it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div><p class="drawer__t"><a href="' + escapeHtml(it.url) + '">' + title + '</a></p>' +
        '<p class="drawer__meta">' + meta.join(' · ') + '</p>' +
        '<div class="drawer__row"><div class="qty" role="group" aria-label="' + escapeHtml(S.quantity) + '">' +
        '<button type="button" class="qty__btn" data-list-qty="-1" data-key="' + escapeHtml(it.key) + '" aria-label="' + escapeHtml(S.decrease + ': ' + it.title) + '">' + iconSvg('M5 12h14') + '</button>' +
        '<span class="qty__input" style="display:grid;place-items:center" aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" class="qty__btn" data-list-qty="1" data-key="' + escapeHtml(it.key) + '" aria-label="' + escapeHtml(S.increase + ': ' + it.title) + '">' + iconSvg('M12 5v14M5 12h14') + '</button>' +
        '</div><button type="button" class="drawer__rm" data-list-remove data-key="' + escapeHtml(it.key) + '">' + escapeHtml(S.remove) + '</button></div></div>' +
        '</li>';
    }).join('');
  }

  /* ---------------- Drawer ---------------- */
  var Drawer = {
    el: null,
    lastFocus: null,
    open: function (trigger) {
      this.el = this.el || $('[data-order-drawer]');
      if (!this.el) return;
      this.lastFocus = trigger || document.activeElement;
      render();
      this.el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('drawer-open');
      var panel = $('.drawer__panel', this.el);
      if (panel) panel.focus();
    },
    close: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); Drawer.open(e.target.closest('[data-drawer-open]')); return; }
    if (e.target.closest('[data-drawer-close]')) { Drawer.close(); return; }
    var q = e.target.closest('[data-list-qty]');
    if (q) {
      var key = q.getAttribute('data-key');
      var item = OrderList.read().filter(function (i) { return i.key === key; })[0];
      if (item) OrderList.setQty(key, Math.min(99, item.quantity + Number(q.getAttribute('data-list-qty'))));
      return;
    }
    var rm = e.target.closest('[data-list-remove]');
    if (rm) { OrderList.setQty(rm.getAttribute('data-key'), 0); return; }
    if (e.target.closest('[data-order-clear]')) { OrderList.clear(); return; }
    if (e.target.closest('[data-order-send]')) {
      var items = OrderList.read();
      if (!items.length) return;
      var ok = openWhatsApp(buildMessage(items));
      var fb = $('[data-order-fallback]');
      if (fb) fb.textContent = ok ? '' : (validNumber() ? S.blocked : S.invalidNumber);
    }
  });

  // Keep focus inside the drawer and close on Escape.
  document.addEventListener('keydown', function (e) {
    var drawer = $('[data-order-drawer]');
    if (drawer && !drawer.hidden) {
      if (e.key === 'Escape') { Drawer.close(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', drawer).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === OrderList.key) render(); });

  /* ---------------- Header ---------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var menuBtn = $('[data-menu-toggle]', header);
    var menu = $('[data-mobile-menu]', header);
    var searchBtn = $('[data-search-toggle]', header);
    var search = searchBtn ? document.getElementById(searchBtn.getAttribute('aria-controls')) : null;

    function setMenu(open) {
      if (!menuBtn || !menu) return;
      menuBtn.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      header.classList.toggle('is-menu-open', open);
      if (open) { var l = $('a, button', menu); if (l) l.focus(); }
    }
    function setSearch(open) {
      if (!searchBtn || !search) return;
      searchBtn.setAttribute('aria-expanded', String(open));
      search.hidden = !open;
      header.classList.toggle('is-menu-open', open || (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true'));
      if (open) { var i = $('input[type="search"]', search); if (i) i.focus(); }
    }

    if (menuBtn) menuBtn.addEventListener('click', function () {
      var open = menuBtn.getAttribute('aria-expanded') !== 'true';
      setSearch(false); setMenu(open);
    });
    if (searchBtn) searchBtn.addEventListener('click', function () {
      var open = searchBtn.getAttribute('aria-expanded') !== 'true';
      setMenu(false); setSearch(open);
    });

    header.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); }
      if (searchBtn && searchBtn.getAttribute('aria-expanded') === 'true') { setSearch(false); searchBtn.focus(); }
      $$('details[open]', header).forEach(function (d) { d.removeAttribute('open'); var s = $('summary', d); if (s) s.focus(); });
    });

    // Close desktop dropdowns when clicking elsewhere.
    document.addEventListener('click', function (e) {
      $$('details[data-dropdown][open]', header).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });

    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-btn]');
    if (!btn) return;
    var item = btn.closest('[data-accordion]');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    if (panel) panel.hidden = !open;
    if (item) item.classList.toggle('is-open', open);
  });

  /* ---------------- Tabs ---------------- */
  function activateTab(tab) {
    var list = tab.closest('[data-tabs]');
    if (!list) return;
    $$('[data-tab]', list).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', String(on));
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (tab) activateTab(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End')) return;
    var tabs = $$('[data-tab]', tab.closest('[data-tabs]'));
    var i = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
    if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
    if (e.key === 'Home') i = 0;
    if (e.key === 'End') i = tabs.length - 1;
    e.preventDefault();
    tabs[i].focus();
    activateTab(tabs[i]);
  });

  /* ---------------- Carousel ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var root = btn.closest('[data-carousel-root]');
    var track = root && $('[data-carousel-track]', root);
    if (!track) return;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
  });

  /* ---------------- Scroll reveal ----------------
   * Content is only hidden once this script has taken charge (html.reveal-ready),
   * and anything at or above the viewport is shown immediately, so a missed
   * observer callback can never leave a section invisible.
   */
  function initReveal() {
    if (!document.body.classList.contains('has-reveal')) return;
    var els = $$('.reveal');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var pending = els.slice();
    function show(el) { el.classList.add('is-visible'); }
    function sweep() {
      var limit = window.innerHeight * 0.95;
      pending = pending.filter(function (el) {
        if (el.getBoundingClientRect().top < limit) { show(el); return false; }
        return true;
      });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sweep(); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0 });
    document.documentElement.classList.add('reveal-ready');
    sweep();
    pending.forEach(function (el) { io.observe(el); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Final safety net: never leave anything hidden for long.
    setTimeout(function () { pending.forEach(show); pending = []; }, 4000);
  }

  /* ---------------- Product gallery ---------------- */
  var Gallery = {
    slides: function (gal) { return $$('[data-gallery-slide]', gal); },
    setActive: function (gal, index) {
      var slides = this.slides(gal);
      slides.forEach(function (sl, i) {
        var on = i === index;
        sl.classList.toggle('is-active', on);
        if (!on) $$('video', sl).forEach(function (vid) { try { vid.pause(); } catch (e) { /* ignore */ } });
      });
      $$('[data-gallery-thumb]', gal).forEach(function (t) {
        var on = Number(t.getAttribute('data-gallery-thumb')) === index;
        t.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          var list = t.closest('.gal__thumbs');
          if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.offsetLeft - list.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      var cur = $('[data-gallery-current]', gal);
      if (cur) cur.textContent = index + 1;
      gal._index = index;
    },
    go: function (gal, index, smooth) {
      var slides = this.slides(gal);
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      var track = $('[data-gallery-track]', gal);
      if (track) track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      this.setActive(gal, index);
    },
    goToMedia: function (root, mediaId) {
      var gal = $('[data-gallery]', root);
      if (!gal) return;
      var slide = $('[data-gallery-slide][data-media-id="' + mediaId + '"]', gal);
      if (slide) this.go(gal, Number(slide.getAttribute('data-index')));
    }
  };

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-gallery-prev], [data-gallery-next]');
    if (nav) {
      var gal = nav.closest('[data-gallery]');
      Gallery.go(gal, (gal._index || 0) + (nav.hasAttribute('data-gallery-next') ? 1 : -1));
      return;
    }
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) Gallery.go(thumb.closest('[data-gallery]'), Number(thumb.getAttribute('data-gallery-thumb')));
  });

  // Swiping the track (touch or trackpad) updates thumbnails and the counter.
  var galTick = false;
  document.addEventListener('scroll', function (e) {
    var track = e.target && e.target.matches && e.target.matches('[data-gallery-track]') ? e.target : null;
    if (!track || galTick) return;
    galTick = true;
    window.requestAnimationFrame(function () {
      galTick = false;
      var gal = track.closest('[data-gallery]');
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (gal && i !== gal._index) Gallery.setActive(gal, i);
    });
  }, true);

  document.addEventListener('keydown', function (e) {
    var track = e.target.matches && e.target.matches('[data-gallery-track]') ? e.target : null;
    if (!track || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
    e.preventDefault();
    var gal = track.closest('[data-gallery]');
    Gallery.go(gal, (gal._index || 0) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  /* ---------------- Image zoom (lightbox) ---------------- */
  var Lightbox = {
    dlg: null,
    slides: function () { return this.dlg ? $$('[data-lb-slide]', this.dlg) : []; },
    show: function (index) {
      var slides = this.slides();
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      slides.forEach(function (sl, i) {
        sl.hidden = i !== index;
        sl.classList.remove('is-zoomed');
        var z = $('[data-lb-zoom]', sl);
        if (z) z.setAttribute('aria-pressed', 'false');
      });
      this.index = index;
      var cur = $('[data-lb-current]', this.dlg);
      if (cur) cur.textContent = index + 1;
    },
    open: function (trigger) {
      var sec = trigger.closest('.mp-sec');
      this.dlg = sec && $('[data-lightbox]', sec);
      if (!this.dlg || typeof this.dlg.showModal !== 'function') return;
      var id = trigger.getAttribute('data-lightbox-open');
      var idx = 0;
      this.slides().forEach(function (sl, i) { if (sl.getAttribute('data-media-id') === id) idx = i; });
      this.show(idx);
      this.dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      var close = $('[data-lightbox-close]', this.dlg);
      if (close) close.focus();
    },
    close: function () { if (this.dlg && this.dlg.open) this.dlg.close(); }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lightbox-open]');
    if (opener) { Lightbox.open(opener); return; }
    if (!Lightbox.dlg || !Lightbox.dlg.open) return;
    if (e.target === Lightbox.dlg || e.target.closest('[data-lightbox-close]')) { Lightbox.close(); return; }
    if (e.target.closest('[data-lb-prev]')) { Lightbox.show(Lightbox.index - 1); return; }
    if (e.target.closest('[data-lb-next]')) { Lightbox.show(Lightbox.index + 1); return; }
    var z = e.target.closest('[data-lb-zoom]');
    if (z) {
      var slide = z.closest('[data-lb-slide]');
      var rect = z.getBoundingClientRect();
      var fx = rect.width ? (e.clientX - rect.left) / rect.width : 0.5;
      var fy = rect.height ? (e.clientY - rect.top) / rect.height : 0.5;
      var on = !slide.classList.contains('is-zoomed');
      slide.classList.toggle('is-zoomed', on);
      z.setAttribute('aria-pressed', String(on));
      if (on) {
        // Keep the tapped point under the finger after zooming in.
        slide.scrollLeft = fx * slide.scrollWidth - slide.clientWidth / 2;
        slide.scrollTop = fy * slide.scrollHeight - slide.clientHeight / 2;
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!Lightbox.dlg || !Lightbox.dlg.open) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); Lightbox.show(Lightbox.index + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); Lightbox.show(Lightbox.index - 1); }
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lightbox]')) document.documentElement.style.overflow = '';
  }, true);

  /* ---------------- Product page: details link ---------------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-open-details]');
    if (!link) return;
    var btn = document.getElementById(link.getAttribute('data-open-details'));
    if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
  });

  /* ---------------- Mobile sticky order bar ---------------- */
  function initStickyBar(root) {
    if (!('IntersectionObserver' in window)) return;
    $$('[data-sticky-bar]', root).forEach(function (bar) {
      if (bar._io) return;
      var card = bar.closest('[data-product-card]');
      var actions = card && $('[data-mp-actions]', card);
      if (!actions) return;
      var link = $('a', bar);
      bar._io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        // Only after the main buttons have scrolled up out of view — never before them.
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('mp-bar-on', show);
        if (show) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); if (link) link.removeAttribute('tabindex'); }
        else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); if (link) link.setAttribute('tabindex', '-1'); }
      });
      bar._io.observe(actions);
    });
  }

  /* ---------------- Related products ---------------- */
  function initRecommendations(root) {
    $$('[data-recs]', root).forEach(function (sec) {
      if (sec._recs) return;
      sec._recs = true;
      var target = $('[data-recs-grid]', sec);
      var finish = function () {
        if (!$('.pgrid__item', target) && !CONFIG.designMode) sec.hidden = true;
      };
      var url = sec.getAttribute('data-url');
      if (!url || !window.fetch) { finish(); return; }
      var load = function () {
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var grid = doc.querySelector('[data-recs-grid] .pgrid');
              if (grid && grid.querySelector('.pgrid__item')) {
                target.innerHTML = grid.outerHTML;
                $$('[data-product-card]', target).forEach(syncCard);
              }
            }
            finish();
          })
          .catch(finish);
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(sec);
    });
  }

  /* ---------------- Collection filters and sorting ----------------
   * Plain GET form so filters work without JavaScript; with it, checkbox and
   * sort changes submit straight away and empty fields are left out of the URL.
   */
  function submitFacets(form) {
    $$('input, select', form).forEach(function (el) { if (!el.value && el.type !== 'checkbox') el.disabled = true; });
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-facets-form]');
    if (!form) return;
    if (e.target.type === 'checkbox' || e.target.matches('[data-facet-sort]')) submitFacets(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-facets-form]');
    if (form) $$('input, select', form).forEach(function (el) { if (!el.value && el.type !== 'checkbox') el.disabled = true; });
  });
  // Only one filter panel open at a time; close on outside click or Escape.
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('[data-facet]') || !e.target.open) return;
    $$('[data-facet][open]').forEach(function (d) { if (d !== e.target) d.open = false; });
  }, true);
  document.addEventListener('click', function (e) {
    $$('[data-facet][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-facet][open]').forEach(function (d) { d.open = false; var sm = $('summary', d); if (sm) sm.focus(); });
  });

  /* ---------------- Announcement marquee ----------------
   * The first group holds the real messages. Copies are added (hidden from
   * assistive tech and keyboard) until the strip is wide enough to loop
   * seamlessly; the track then moves by exactly one group width.
   */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function initMarquee(root) {
    $$('[data-marquee]', root).forEach(function (bar) {
      var track = $('[data-marquee-track]', bar);
      var group = $('[data-marquee-group]', bar);
      if (!track || !group) return;
      $$('[data-marquee-clone]', track).forEach(function (c) { c.remove(); });
      bar.classList.remove('is-running');
      if (reduceMotion && reduceMotion.matches) return;
      // Measure the group on one line (as it will scroll), not wrapped.
      bar.classList.add('is-running', 'is-measuring');
      var gw = group.getBoundingClientRect().width;
      var vw = bar.clientWidth;
      bar.classList.remove('is-measuring');
      if (!gw || !vw) { bar.classList.remove('is-running'); return; }
      var copies = Math.max(1, Math.ceil((vw * 2) / gw));
      for (var i = 0; i < copies; i++) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-marquee-clone', '');
        clone.removeAttribute('data-marquee-group');
        clone.setAttribute('inert', '');
        $$('a, button', clone).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        track.appendChild(clone);
      }
      var speed = Number(bar.getAttribute('data-speed')) || 45;
      bar.style.setProperty('--marquee-shift', -gw + 'px');
      bar.style.setProperty('--marquee-duration', (gw / speed).toFixed(2) + 's');
      bar.classList.toggle('is-reverse', bar.getAttribute('data-direction') === 'right');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-marquee-toggle]');
    if (!t) return;
    var bar = t.closest('[data-marquee]');
    var paused = bar.classList.toggle('is-paused');
    t.setAttribute('aria-pressed', String(paused));
    t.setAttribute('aria-label', t.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
  });
  var marqueeResize;
  window.addEventListener('resize', function () { clearTimeout(marqueeResize); marqueeResize = setTimeout(function () { initMarquee(document); }, 250); });
  if (reduceMotion && reduceMotion.addEventListener) reduceMotion.addEventListener('change', function () { initMarquee(document); });

  /* ---------------- Age gate ---------------- */
  function initAgeGate() {
    var gate = $('[data-age-gate]');
    if (!gate) return;
    var KEY = 'vs-age-confirmed';
    var ok = false;
    try { ok = window.localStorage.getItem(KEY) === '1'; } catch (e) { ok = false; }
    if (ok) return;
    gate.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var btn = $('[data-age-confirm]', gate);
    if (btn) {
      btn.focus();
      btn.addEventListener('click', function () {
        try { window.localStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
        gate.hidden = true;
        document.documentElement.style.overflow = '';
      });
    }
  }

  /* ---------------- Theme editor support ---------------- */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-header]')) initHeader();
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
    $$('[data-product-card]', e.target).forEach(syncCard);
    initStickyBar(e.target);
    initRecommendations(e.target);
    initMarquee(e.target);
    render();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.matches && e.target.matches('[data-tab]') ? e.target : null;
    if (tab) activateTab(tab);
    var acc = e.target.closest && e.target.closest('[data-accordion]');
    if (acc) {
      var b = $('[data-accordion-btn]', acc);
      if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
    }
  });

  /* ---------------- Init ---------------- */
  function init() {
    initHeader();
    initReveal();
    initAgeGate();
    render();
    $$('[data-product-card]').forEach(syncCard);
    initStickyBar(document);
    initRecommendations(document);
    initMarquee(document);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initMarquee(document); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
